import { render, staticRenderFns } from "./ReferralFeedbackModal.vue?vue&type=template&id=62255f87&scoped=true&"
import script from "./ReferralFeedbackModal.vue?vue&type=script&lang=ts&"
export * from "./ReferralFeedbackModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralFeedbackModal.vue?vue&type=style&index=0&id=62255f87&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62255f87",
  null
  
)

export default component.exports